import safeJSONParse from '@/utils/safeJSONParse'

export default {
  getItem: (key, format) => {
    try {
      const value = localStorage.getItem(key)
      return format === 'json' ? safeJSONParse(value) : value
    } catch (e) {
      console.error(e)
    }
  },
  setItem: (key, value) => {
    try {
      value = typeof value === 'object' ? JSON.stringify(value) : value
      return localStorage.setItem(key, value)
    } catch (e) {
      console.error(e)
    }
  },
  removeItem: key => {
    try {
      return localStorage.removeItem(key)
    } catch (e) {
      console.error(e)
    }
  }
}
